import { Project } from '../types';
import { ui } from './ui';

const bishaAiScreenshots = Array.from({ length: 11 }, (_, i) => `/images/RAG/${i}.jpeg`);

export const projects: Project[] = [
  {
    id: 'bisha-private-ai',
    name: 'Private AI Platform',
    company: 'جامعة بيشة',
    type: 'منصة ذكاء اصطناعي خاصة / شات بوت',
    categories: ['AI', 'Web', 'Backend', 'Enterprise', 'Education'],
    role: 'مهندس ذكاء اصطناعي أول / مطور منصة AI',
    description:
      'صمّمت وطوّرت منصة شات بوت ذكاء اصطناعي خاصة (On-Premise) لجامعة بيشة، تعمل بالكامل على خوادم الجامعة وبنية GPU دون الاعتماد على واجهات AI خارجية.',
    shortDescription:
      'شات بوت AI خاص على بنية GPU الجامعة — n8n، Docker، NestJS + React، ودعم قياس التحول الرقمي (خدمات المستفيدين).',
    technologies: [
      'LLM',
      'AI / RAG',
      'n8n',
      'Docker',
      'NestJS',
      'React',
      'GPU Infrastructure',
      'REST APIs',
      'Linux',
    ],
    companyLogo: '/images/companies/rmg.png',
    projectImage: '/images/RAG/0.jpeg',
    projectUrl: '',
    githubUrl: '',
    caseStudyUrl: '',
    estimatedCost: '',
    status: 'نشط',
    featured: true,
    overview:
      'منصة ذكاء اصطناعي خاصة لجامعة بيشة تدمج نموذج LLM داخلياً مع سير عمل n8n آلي، ولوحة إدارة ومحادثة مخصصة. الهدف تقديم خدمات مدعومة بالذكاء الاصطناعي مع السيطرة الكاملة على البيانات والبنية، ودعم متطلبات قياس التحول الرقمي الصادرة عن هيئة الحكومة الرقمية — خاصة توظيف التقنيات الناشئة لتعزيز مشاركة المستفيد (المعيار 5.18.4).',
    problem:
      'تحتاج الجامعة بيئة AI آمنة ومحلية تخدم المستفيدين دون إرسال البيانات لخدمات سحابية خارجية، مع قابلية التوسع وربط المعرفة الجامعية مستقبلاً.',
    solution:
      'بنية containerized على Docker، تشغيل LLM على GPU الجامعة، أتمتة عبر n8n، وواجهات NestJS + React لإدارة المحادثات والنظام — منصة AI خاصة قابلة للصيانة والتوسع.',
    keyFeatures: [
      'نشر بنية AI باستخدام Docker وخدمات containerized',
      'تشغيل LLM داخلي على بنية GPU الجامعة',
      'سير عمل وأتمتة AI عبر n8n',
      'لوحة إدارة ومحادثة مخصصة — NestJS و React',
      'واجهات API لإدارة تفاعلات AI ووظائف النظام',
      'جاهزية لدمج قاعدة معرفة جامعية',
      'دعم مبادرات التحول الرقمي وخدمات المستفيدين بالتقنيات الناشئة',
    ],
    architecture:
      'LLM على GPU + Docker + n8n للأتمتة والتنسيق + NestJS (Backend) + React (Dashboard) على Linux — بيئة AI خاصة On-Premise.',
    screenshots: bishaAiScreenshots,
    companyInfo: 'RMG / جامعة بيشة — المملكة العربية السعودية',
  },
  {
    id: 'myub',
    name: 'MyUB',
    company: 'جامعة بيشة',
    type: 'خدمات جامعية / تطبيق موبايل',
    categories: ['Mobile', 'Education', 'Enterprise'],
    role: 'مطور تطبيقات موبايل أول',
    description:
      'تطبيق موبايل لخدمات جامعة بيشة — حضور الموظفين حسب الموقع وخدمات الحرم الجامعي (إلى جانب منصة Private AI Platform).',
    shortDescription: 'تطبيق React Native لخدمات الجامعة — حضور موظفين وخدمات حرم جامعي.',
    technologies: ['React Native', 'Firebase', 'REST APIs', 'Mobile Architecture'],
    companyLogo: '/images/companies/rmg.png',
    projectImage: '/images/projects/myub.png',
    projectUrl: '',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=sa.edu.myub',
    appStoreUrl: 'https://apps.apple.com/jo/app/myub-university/id6471832081',
    githubUrl: '',
    caseStudyUrl: '',
    estimatedCost: '',
    status: 'نشط',
    featured: true,
    overview:
      'MyUB تطبيق شامل لخدمات جامعة بيشة، يوفر وصولاً عبر الموبايل لخدمات الحرم بما في ذلك تتبع حضور الموظفين عبر المباني المختلفة.',
    problem:
      'يعمل موظفو الجامعة عبر مباني متعددة ويحتاجون لتتبع حضور حسب الموقع متكامل مع خدمات الحرم الأوسع.',
    solution:
      'بناء تطبيق موبايل مع حضور حسب الموقع وتطوير المنصة بأنظمة استرجاع معرفة مدعومة بالذكاء الاصطناعي لحالات الاستخدام الجامعية.',
    keyFeatures: [
      'حضور الموظفين مع الوعي بالموقع',
      'الوصول لخدمات الجامعة',
      'استرجاع معرفة مدعوم بالذكاء الاصطناعي',
      'تكامل نظام RAG محلي',
    ],
    architecture:
      'تطبيق موبايل مع خدمات خلفية، يتطور إلى منصة معززة بالذكاء الاصطناعي مع بنية RAG محلية للمعرفة المؤسسية.',
    screenshots: ['/images/projects/myub.png'],
    companyInfo: 'RMG — الرياض، المملكة العربية السعودية',
  },
  {
    id: 'soalk',
    name: 'Soalk',
    company: 'BEECell',
    type: 'تطبيق تواصل اجتماعي',
    categories: ['Mobile', 'Enterprise'],
    role: 'مهندس Java / مطور React Native',
    description:
      'تطبيق تواصل اجتماعي يركز على الأسئلة والتفاعل الاجتماعي مع دعم أنواع محتوى متعددة.',
    shortDescription: 'منصة أسئلة وأجوبة اجتماعية مع فيديو وصوت وصور ونص.',
    technologies: ['Java', 'React Native'],
    companyLogo: '/images/companies/beecell2.png',
    projectImage: '/images/projects/soalak.png',
    projectUrl: '',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.beecell.so2alak',
    githubUrl: '',
    caseStudyUrl: '',
    estimatedCost: '',
    status: 'مكتمل',
    featured: false,
    overview: 'تطبيق تواصل اجتماعي يتفاعل فيه المستخدمون عبر الأسئلة وأشكال محتوى متنوعة.',
    keyFeatures: ['متابعة، إعجاب، مشاركة', 'فيديوهات قصيرة، صوت، صور، نص', 'تفاعل اجتماعي'],
    screenshots: ['/images/projects/soalak.png'],
  },
  {
    id: 'joacademy',
    name: 'JoAcademy',
    company: 'JoAcademy',
    type: 'منصة تعليمية',
    categories: ['Mobile', 'Education', 'Web'],
    role: 'مطور تطبيقات موبايل أول',
    description:
      'منصة تعليمية للطلاب والمحتوى التعليمي مع أمان متقدم للمحتوى المحمي.',
    shortDescription: 'منصة تعليمية مع حماية محتوى وأمان موبايل.',
    technologies: ['React Native', 'React', 'أمان الموبايل', 'Firebase'],
    companyLogo: '/images/companies/joAcademy.png',
    projectImage: '/images/projects/joAcademy.png',
    projectUrl: '',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.jo_Joacademy',
    appStoreUrl: 'https://apps.apple.com/jo/app/jo-academy/id1667155848',
    githubUrl: '',
    caseStudyUrl: '',
    estimatedCost: '',
    status: 'مكتمل',
    featured: true,
    overview: 'JoAcademy منصة تعليمية تقدم المحتوى للطلاب مع آليات أمان قوية.',
    keyFeatures: [
      'توصيل المحتوى التعليمي',
      'آليات حماية المحتوى',
      'أمان تطبيقات الموبايل',
      'تطوير React Native وReact',
    ],
    screenshots: ['/images/projects/joAcademy.png'],
  },
  {
    id: 'waslk',
    name: 'WASLK',
    type: 'تجارة B2B / سوق جملة',
    categories: ['Mobile', 'E-commerce', 'Marketplace', 'Web', 'Backend'],
    role: 'مدير تقني (CTO)',
    description:
      'بمساعدة الذكاء الاصطناعي، بنيت تطبيقاً Full-Stack حقيقياً يعمل في السوق الفعلي وحقّق أرباحاً تجاوزت 50,000 دينار أردني. المنصة تربط الموردين ومتاجر البقالة عبر تطبيق موبايل ولوحة تحكم إدارية.',
    shortDescription:
      'منصة B2B حقيقية — NestJS + React + React Native + MySQL على DigitalOcean، بأرباح +10K JOD خلال 3 أشهر.',
    technologies: ['NestJS', 'React', 'React Native', 'MySQL', 'DigitalOcean', 'Android', 'iOS'],
    companyLogo: '/images/companies/waslk.png',
    projectImage: '/images/projects/waslk.png',
    projectUrl: '',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.waslk.jo',
    appStoreUrl: 'https://apps.apple.com/jo/app/waslk-%D9%88%D8%A7%D8%B5%D9%84%D9%83/id6769897958',
    githubUrl: '',
    caseStudyUrl: '',
    estimatedCost: '',
    status: 'نشط',
    featured: true,
    overview:
      'WASLK منصة تجارة B2B تمكّن متاجر البقالة من طلب منتجات الجملة رقمياً من الموردين والمستودعات. بمساعدة الذكاء الاصطناعي، طوّرت المنصة كاملة خلال 3 أشهر كمنتج حقيقي يعمل في السوق وحقّق أرباحاً تجاوزت 50,000 دينار أردني.',
    problem: 'تحتاج متاجر البقالة قناة رقمية فعالة لطلب منتجات الجملة من موردين متعددين.',
    solution:
      'بناء منصة Full-Stack متكاملة: NestJS للخلفية، React للوحة التحكم الإدارية، React Native لتطبيقات Android وiOS، مع MySQL واستضافة على DigitalOcean.',
    keyFeatures: [
      'تطبيق موبايل React Native — Android و iOS',
      'لوحة تحكم إدارية React',
      'خلفية NestJS مع MySQL',
      'استضافة على DigitalOcean',
      'منتج حقيقي بأرباح +10K JOD',
      'بُني خلال 3 أشهر بمساعدة الذكاء الاصطناعي',
    ],
    architecture:
      'NestJS API + MySQL على DigitalOcean، لوحة تحكم React، وتطبيق React Native للموبايل — منصة B2B متعددة الأطراف لإدارة الموردين ومتاجر البقالة ومعالجة الطلبات.',
    screenshots: ['/images/projects/waslk.png'],
  },
  {
    id: 'dufaty',
    name: 'Dufaty',
    type: 'FinTech / BNPL',
    categories: ['Mobile', 'FinTech'],
    role: 'باني منتجات',
    description: 'مشروع اشتر الآن وادفع لاحقاً في رام الله، يتيح خيارات دفع مرنة للمستهلكين.',
    shortDescription: 'تطبيق FinTech اشتر الآن وادفع لاحقاً في رام الله.',
    technologies: ['[أضف التقنيات]'],
    companyLogo: '/images/companies/dufaty.png',
    projectImage: '/images/projects/dufaty.png',
    projectUrl: '',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.dufaty',
    appStoreUrl: 'https://apps.apple.com/jo/app/dufaaty/id6738010041',
    githubUrl: '',
    caseStudyUrl: '',
    estimatedCost: '[أضف التكلفة التقديرية]',
    status: '[أضف الحالة]',
    featured: true,
    overview: 'منتج FinTech مستقل ينفذ مفهوم اشتر الآن وادفع لاحقاً.',
    keyFeatures: ['اشتر الآن وادفع لاحقاً', 'مرونة الدفع للمستهلك'],
    screenshots: ['/images/projects/dufaty.png'],
  },
  {
    id: 'ordera',
    name: 'Ordera',
    type: 'سوق متعدد المتاجر / إدارة مطاعم ومتاجر',
    categories: ['Mobile', 'Marketplace', 'E-commerce'],
    role: 'باني منتجات',
    description:
      'منصة لإدارة متاجر متعددة ضمن تطبيق موبايل واحد، تتيح لعدة مسؤولين/متاجر العمل ضمن نفس النظام.',
    shortDescription: 'منصة سوق متعددة المتاجر بمفهوم مشابه لـ Talabat.',
    technologies: ['[أضف التقنيات]'],
    companyLogo: '/images/companies/ordera2.png',
    projectImage: '/images/projects/ordera2.png',
    projectUrl: '',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.mohdsh85.restaurantapp',
    githubUrl: '',
    caseStudyUrl: '',
    estimatedCost: '[أضف التكلفة التقديرية]',
    status: '[أضف الحالة]',
    featured: true,
    overview: 'Ordera منصة سوق متعددة المتاجر تمكّن عدة متاجر ومسؤولين من العمل ضمن نظام موحد.',
    problem: 'تحتاج الأعمال منصة واحدة لإدارة متاجر متعددة مع مسؤولين مستقلين ضمن تطبيق واحد.',
    solution: 'بناء بنية سوق متعددة المستأجرين تدعم متاجر ومسؤولين متعددين وإدارة الطلبات.',
    keyFeatures: [
      'إدارة متاجر متعددة',
      'دعم مسؤولين متعددين',
      'نظام سوق موحد',
      'عمليات مطاعم ومتاجر',
    ],
    architecture: 'سوق متعدد المستأجرين مع بنية تحتية مشتركة وإدارة لكل متجر.',
    screenshots: ['/images/projects/ordera2.png'],
  },
  {
    id: 'opensooq',
    name: 'OpenSooq',
    company: 'Open Sooq',
    type: 'سوق إلكتروني / إعلانات مبوبة',
    categories: ['Web', 'Backend', 'Marketplace', 'Enterprise'],
    role: 'مطور خلفية PHP / Yii2',
    description:
      'السوق المفتوح — من أكبر منصات الإعلانات المبوبة في العالم العربي، تمكّن المستخدمين من بيع وشراء السلع والخدمات عبر الأردن.',
    shortDescription: 'سوق إلكتروني للإعلانات المبوبة — سيارات، عقارات، وظائف، وخدمات.',
    technologies: ['PHP', 'Yii2', 'REST APIs', 'MySQL'],
    companyLogo: '/images/companies/opensooq.png',
    projectImage: '/images/projects/opensooq.png',
    projectUrl: 'https://jo.opensooq.com/ar',
    githubUrl: '',
    caseStudyUrl: '',
    estimatedCost: '',
    status: 'مكتمل',
    featured: true,
    overview:
      'OpenSooq (السوق المفتوح) منصة إعلانات مبوبة رائدة في الأردن والمنطقة، تربط البائعين والمشترين عبر فئات متعددة مثل السيارات والعقارات والوظائف والخدمات.',
    problem:
      'يحتاج ملايين المستخدمين منصة موثوقة وسريعة للإعلان عن المنتجات والخدمات والتواصل المباشر مع المشترين.',
    solution:
      'المساهمة في تطوير أنظمة الخلفية وأدوات داخلية تدعم منصة السوق المفتوح وعملياتها التشغيلية.',
    keyFeatures: [
      'منصة إعلانات مبوبة متعددة الفئات',
      'سيارات وعقارات ووظائف وخدمات',
      'أنظمة مبيعات داخلية وواجهات API',
      'منطق أعمال ولوحات تحكم',
    ],
    architecture: 'منصة ويب واسعة النطاق مع خلفية PHP/Yii2 وأنظمة داخلية لدعم العمليات.',
    screenshots: ['/images/projects/opensooq.png'],
    companyInfo: 'Open Sooq — الأردن',
  },
  {
    id: 'alinma-bank',
    name: 'بنك الإنماء',
    company: 'Deloitte',
    type: 'تطبيق مصرفي مؤسسي',
    categories: ['Mobile', 'Enterprise', 'FinTech'],
    role: 'مستشار تطبيقات موبايل',
    description: 'استشارات تطبيقات موبايل مؤسسية لمشروع مصرفي كبير ضمن ممارسات هندسة برمجيات احترافية.',
    shortDescription: 'استشارات تطبيق موبايل مصرفي مؤسسي.',
    technologies: ['تطوير الموبايل', 'تطبيقات مؤسسية'],
    companyLogo: '/images/companies/deloitte.png',
    projectImage: '/images/projects/alinma.png',
    projectUrl: '',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.alinma.retail.mobile.v4',
    appStoreUrl: 'https://apps.apple.com/jo/app/alinma-app-%D8%AA%D8%B7%D8%A8%D9%8A%D9%82-%D8%A7%D9%84%D8%A5%D9%86%D9%85%D8%A7%D8%A1/id1668637683',
    githubUrl: '',
    caseStudyUrl: '',
    estimatedCost: '',
    status: 'مكتمل',
    featured: false,
    overview: 'استشارات تطبيقات موبايل لمشروع بنك الإنماء المصرفي المؤسسي.',
    keyFeatures: ['تطوير موبايل مؤسسي', 'متطلبات تطبيقات مصرفية'],
    screenshots: ['/images/projects/alinma.png'],
  },
  {
    id: 'salon-app',
    name: 'تطبيق الصالون',
    company: 'Digital Cash',
    type: 'تطبيق حجز',
    categories: ['Mobile'],
    role: 'مطور تطبيقات موبايل',
    description: 'تطبيق يتيح للمستخدمين اكتشاف الصالونات وحجز المواعيد وإدارتها والتفاعل مع خدمات الصالون.',
    shortDescription: 'تطبيق اكتشاف صالونات وحجز مواعيد.',
    technologies: ['React Native', 'تطوير الموبايل'],
    companyLogo: '/images/companies/digitalcash.png',
    projectImage: '/images/projects/salon.png',
    projectUrl: 'https://dg-cash.com/',
    githubUrl: '',
    caseStudyUrl: '',
    estimatedCost: '',
    status: 'مكتمل',
    featured: false,
    overview: 'تطبيق أعمال حقيقي لاكتشاف الصالونات وإدارة المواعيد.',
    keyFeatures: ['اكتشاف الصالونات', 'حجز المواعيد', 'إدارة المواعيد'],
    screenshots: ['/images/projects/salon.png'],
  },
];

export const projectCategories: { id: string; label: string }[] = [
  { id: 'all', label: ui.projectCategories.all },
  { id: 'AI', label: ui.projectCategories.AI },
  { id: 'Mobile', label: ui.projectCategories.Mobile },
  { id: 'Web', label: ui.projectCategories.Web },
  { id: 'Backend', label: ui.projectCategories.Backend },
  { id: 'E-commerce', label: ui.projectCategories['E-commerce'] },
  { id: 'FinTech', label: ui.projectCategories.FinTech },
  { id: 'Education', label: ui.projectCategories.Education },
  { id: 'Enterprise', label: ui.projectCategories.Enterprise },
  { id: 'Marketplace', label: ui.projectCategories.Marketplace },
];

export const independentProductIds = ['waslk', 'dufaty', 'ordera'];
